export const GET_PAST_BOOKINGS = 'get-past-bookings';
const getPastBookings = ({ bookingsQuery, bookingRequest, bookingType, purchaseType }) => ({
  type: GET_PAST_BOOKINGS,
  payload: { bookingsQuery, bookingRequest, bookingType, purchaseType },
});
export default getPastBookings;
